import {
  factory,
  getResponseCamelization,
  snakify,
} from '@repo-level/core-front';
import { isCMSV3 } from 'helpers/conf';
import type { CMSApiBase } from './base';
import { buildCmsUrl, getResponseCMS } from './base';

export interface ThirdPartySummaryCommon {
  userId: number;
  modalId: string;
}

export type ThirdPartySummary = ThirdPartySummaryCommon & CMSApiBase;

export const getThirdPartySummariesV3 = factory(
  (r) => (userId: number) =>
    r<ThirdPartySummary[]>(
      'get',
      buildCmsUrl({
        path: 'third-party-summaries',
        additionalParams: {
          user_id: userId,
        },
      })
    )
);

export const getThirdPartySummariesV4 = factory(
  (r) => (userId: number) =>
    r<ThirdPartySummary[]>(
      'get',
      buildCmsUrl({
        path: 'third-party-summaries',
        additionalParams: {
          user_id: userId,
        },
      }),
      undefined,
      { transformResponse: [getResponseCamelization(), getResponseCMS] }
    )
);

export const getThirdPartySummaries = isCMSV3
  ? getThirdPartySummariesV3
  : getThirdPartySummariesV4;

export const pushThirdPartySummaries = factory(
  (r) => (summary: ThirdPartySummaryCommon) =>
    r<ThirdPartySummary>(
      'post',
      buildCmsUrl({ path: 'third-party-summaries' }),
      snakify(summary)
    )
);
